var PopupTypes;
(function (PopupTypes) {
    PopupTypes["Help"] = "Help";
    PopupTypes["Fairness"] = "Fairness";
    PopupTypes["CheckHash"] = "CheckHash";
    PopupTypes["SlowConnection"] = "SlowConnection";
    PopupTypes["Reconnect"] = "Reconnect";
    PopupTypes["ConnectionError"] = "ConnectionError";
    PopupTypes["ProfileAvatar"] = "ProfileAvatar";
})(PopupTypes || (PopupTypes = {}));

export { PopupTypes };
